import { BasicLayout } from '@1x2network/layout'
import { slotStore } from '@1x2network/slot-ui'
import { Container, Rectangle } from 'pixi.js'
import { Signal } from 'typed-signals'

/**
 * Handles clicks on the stage. Crazy Tiki doesn't have any other interactive objects,
 * so it disables interaction on all other objects.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class ClickHandler {
    public readonly onClick = new Signal<() => void>()

    constructor(stage: Container, layout: BasicLayout) {
        stage.eventMode = 'static'
        stage.interactive = true
        stage.interactiveChildren = false
        stage.on('pointerdown', () => this.onClick.emit())

        // Set hit area
        stage.hitArea = new Rectangle(layout.left, layout.top, layout.size.width, layout.size.height)
        layout.onResize.connect(() => {
            stage.hitArea = new Rectangle(layout.left, layout.top, layout.size.width, layout.size.height)
        })

        /** Connect click to spacebar */
        window.addEventListener('keydown', (event) => {
            if (event.code !== 'Space' || event.repeat) {
                return
            }

            /** check setting enabled */
            const spinOnSpace = slotStore.getState().settings.spacebar.value
            const isSpinning = slotStore.getState().console.value === 'spinning'

            if (isSpinning && spinOnSpace) {
                this.onClick.emit()
            }
        })
    }
}
